import _ from 'lodash';
import { FILTER_LIBRARY_ITEMS } from '../filter/filter-actions';
import { NUMBER_OF_LOADING_ITEMS } from '../../config';
import {
    LIBRARY_ITEMS_LOADED,
    LIBRARY_ITEM_SELECTED,
    LIBRARY_ITEM_LOAD_FAILED,
    LIBRARY_ITEM_LOADED,
    RELOAD_FILTERED_ITEMS,
    LOAD_MORE_LIBRARY_ITEMS
} from './library-actions';

export default (state = {}, action) => {
    switch (action.type) {
        case FILTER_LIBRARY_ITEMS: {
            let resultSummaryText = 'Showing all results';
            let filteredItems = state.allItems || [];
            let yearGroupNames = [];
            let itemTypes = [];
            let categories = [];
            let renderedItems = [];
            let concateSearchTerm = '';
            const searchTerm = action.filter.searchTerm;
            const selectedSeries = action.filter.yearGroups.filter(yearGroup => yearGroup.checked);
            const selectedItemTypes = action.filter.itemTypes.filter(type => type.checked);
            const selectedCategories = action.filter.categories.filter(category => category.checked);
            const seriesIds = _.map(selectedSeries, 'id');
            const typeIds = _.map(selectedItemTypes, 'id');
            const categoryIds = _.map(selectedCategories, 'id');

            if (searchTerm !== '') {
                filteredItems = filteredItems.filter(item =>
                    (item.seriesName.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1 ||
                    item.title.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1));
            }

            if (seriesIds.length > 0) {
                filteredItems = filteredItems.filter(item => _.intersection(seriesIds, [item.seriesId]).length > 0);
                yearGroupNames = _.map(selectedSeries, 'name');
            }

            if (typeIds.length > 0) {
                filteredItems = filteredItems.filter(type => _.intersection(typeIds, [type.itemTypeId]).length > 0);
                itemTypes = _.map(selectedItemTypes, 'name');
            }

            if (categoryIds.length > 0) {
                filteredItems = filteredItems.filter(type => _.intersection(categoryIds, [type.categoryId]).length > 0);
                categories = _.map(selectedCategories, 'name');
            }

            renderedItems = filteredItems.filter((item, index) =>
                index < Math.min(NUMBER_OF_LOADING_ITEMS, filteredItems.length));

            if ((seriesIds.length === 0 && categoryIds.length === 0 && typeIds.length === 0) ||
                (seriesIds.length === action.filter.yearGroups.length &&
                    action.filter.categories.length === categoryIds.length &&
                    typeIds.length === action.filter.itemTypes.length)) {
                resultSummaryText = 'Search all results';
            } else {
                const concatenatedFilterNames = _.concat(yearGroupNames, categories, itemTypes);
                concateSearchTerm = _.join(_.compact(concatenatedFilterNames), ', ');
                resultSummaryText = `Search results for${yearGroupNames.length > 0 ? ' Grade' : ''}`;
            }

            return Object.assign({}, state, {
                filteredItems,
                resultSummaryText,
                selectedItemDetail: null,
                renderedItems,
                concateSearchTerm
            });
        }
        case RELOAD_FILTERED_ITEMS: {
            return Object.assign({}, state, {
                selectedItemDetail: null
            });
        }
        case LIBRARY_ITEMS_LOADED: {
            return {
                ...state,
                allItems: action.allItems,
                filteredItems: action.allItems,
                selectedItemDetail: null
            };
        }
        case LIBRARY_ITEM_SELECTED: {
            const libraryItemDetail = state.libraryItemDetail;
            return Object.assign({}, state, {
                libraryItemDetail
            });
        }
        case LIBRARY_ITEM_LOADED: {
            return Object.assign({},
                state, {
                    selectedItemDetail: {
                        items: action.items,
                        selectedItem: action.selectedItem
                    }
                }
            );
        }
        case LIBRARY_ITEM_LOAD_FAILED: {
            return Object.assign({}, state, {
                errorMessage: 'Error occurred while loading the library item detail. Please try again.'
            });
        }
        case LOAD_MORE_LIBRARY_ITEMS: {
            const renderItemsLength = state.renderedItems?.length;
            const renderedItems = [...(state.renderedItems || []), ...state.filteredItems.filter((item, index) => index >= renderItemsLength &&
                index < renderItemsLength + Math.min(action.loadNumber, state.filteredItems.length - renderItemsLength))];
            return { ...state, renderedItems };
        }

        default: {
            return state;
        }
    }
};
